import { useEffect } from 'react';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import { createEFPic } from '@/utils/useEFPic';

const asset = '/media/community/pc/';
const { EFPic } = createEFPic(asset);

export default function TalkWords() {
    const { t } = useLang('communitylang.talkWords');
    const talksData = [
        {
            key: 1,
            text: t('talk_1_text'),
            name: t('talk_1_name'),
            type: 1,
            class: 'item-box-1',
            img: ['avatar_1.png', 'avatar_1.png'],
        },
        {
            key: 2,
            text: t('talk_2_text'),
            name: t('talk_2_name'),
            type: 2,
            class: 'item-box-2',
            img: ['avatar_2.png', 'avatar_2.png'],
        },
        {
            key: 3,
            text: t('talk_3_text'),
            name: t('talk_3_name'),
            type: 1,
            class: 'item-box-3',
            img: ['avatar_3.png', 'avatar_3.png'],
        },
        {
            key: 4,
            text: t('talk_4_text'),
            name: t('talk_4_name'),
            type: 2,
            class: 'item-box-4',
            img: ['avatar_4.png', 'avatar_4.png'],
        },
        {
            key: 5,
            text: t('talk_5_text'),
            name: t('talk_5_name'),
            type: 1,
            class: 'item-box-5',
            img: ['avatar_5.png', 'avatar_5.png'],
        },
        {
            key: 6,
            text: t('talk_6_text'),
            name: t('talk_6_name'),
            type: 2,
            class: 'item-box-6',
            img: ['avatar_6.png', 'avatar_6.png'],
        },
    ];

    useEffect(() => {
        AniContainer.create({
            asyncFromTo: [
                ['.talk-cards .item-box-1', { opacity: 0, y: 0 }, { opacity: 1, y: -20 }, 0.05], // start: 0, end: 0.1
                ['.talk-cards .item-box-2', { opacity: 0, y: 0 }, { opacity: 1, y: -20 }, 0.05], // start: 0.1, end: 0.2
                ['.talk-cards .item-box-3', { opacity: 0, y: 0 }, { opacity: 1, y: -20 }, 0.05], // start: 0.2, end: 0.3
                ['.talk-cards .item-box-4', { opacity: 0, y: 0 }, { opacity: 1, y: -20 }, 0.05], // start: 0.3, end: 0.4
                ['.talk-cards .item-box-5', { opacity: 0, y: 0 }, { opacity: 1, y: -20 }, 0.05], // start: 0.4, end: 0.5
                ['.talk-cards .item-box-6', { opacity: 0, y: 0 }, { opacity: 1, y: -20 }, 0.05], // start: 0.5, end: 0.6
            ],
            triggerElement: '.talk-cards',
            triggerHook: 1,
            offset: '10%',
            duration: '100%',
            asyncTimeLine: [0, 0.05, 0.1, 0.15, 0.2, 0.25],
        });
    }, []);

    return (
        <div className={`talkWords ${css.talkWords}`}>
            <div className="talk-content">
                <p className="talk-title">{t('title')}</p>
            </div>
            <div className="talk-cards">
                {talksData.map((talk, index) => (
                    <div key={talk.key} className={`item-box box-type-${talk.type} ${talk.class}`}>
                        <div className="item-name-box">
                            <EFPic className="avatar-img" name={talk?.img} />
                            <p className="item-name">{talk?.name}</p>
                            <div className={`flag-svg-${index + 1}`} />
                        </div>
                        <div className={`item-text-box item-type-${talk.type}`}>
                            <p className="item-text">{talk?.text}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
